module.exports = __webpack_public_path__ + "static/img/empty_image.png";